var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M8 10v-.5a4.5 4.5 0 1 1 9 0v.5h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1zm4.5-3A2.5 2.5 0 0 0 10 9.5v.5h5v-.5A2.5 2.5 0 0 0 12.5 7z"}));
}

Lock.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Lock;

Lock.default = Lock;
